const mediaItems = [
  {
    id: 1,
    title: '暴走黑料 · 七月娱乐圈最大瓜独家梳理',
    duration: '15:28',
    views: '8.5万',
    tag: '暴走黑料',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20frame%20with%20warm%20golden%20and%20amber%20tones%2C%20abstract%20video%20still%20aesthetic%20suggesting%20entertainment%20content%2C%20mysterious%20atmosphere%20with%20soft%20focus%20effects%2C%20dark%20elegant%20background%20with%20warm%20highlights%2C%20sophisticated%20editorial%20style%2C%20cinematic%20composition%20with%20film%20grain%20texture%2C%20bold%20visual%20for%20media%20player%20thumbnail&width=800&height=500&seq=media-1-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '黑料社深度 · 某顶流商业帝国全景解析',
    duration: '22:15',
    views: '6.8万',
    tag: '黑料社',
    image: 'https://readdy.ai/api/search-image?query=Warm%20dramatic%20abstract%20cinematic%20scene%20with%20golden%20light%20leaks%2C%20entertainment%20video%20aesthetic%20with%20mysterious%20atmosphere%2C%20dark%20background%20with%20rich%20amber%20and%20coral%20tones%2C%20sophisticated%20artistic%20composition%2C%20editorial%20magazine%20quality%2C%20soft%20focus%20and%20grain%20texture%20suggesting%20media%20content%2C%20bold%20thumbnail%20visual&width=800&height=500&seq=media-2-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺翻车合集 · 那些被删减的名场面',
    duration: '18:42',
    views: '5.3万',
    tag: '综艺深扒',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20warm%20amber%20spotlight%20and%20deep%20shadows%2C%20video%20content%20aesthetic%20with%20dramatic%20entertainment%20atmosphere%2C%20dark%20elegant%20background%20with%20golden%20light%20effects%2C%20sophisticated%20editorial%20style%2C%20film%20like%20texture%20and%20grain%2C%20bold%20visual%20for%20media%20platform%20thumbnail%2C%20mysterious%20and%20intriguing&width=800&height=500&seq=media-3-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '网红经济内幕 · 流量变现背后的真相',
    duration: '20:06',
    views: '4.9万',
    tag: '网红观察',
    image: 'https://readdy.ai/api/search-image?query=Golden%20warm%20abstract%20cinematic%20frame%20with%20dramatic%20lighting%20effects%2C%20entertainment%20video%20aesthetic%20suggesting%20exclusive%20content%2C%20dark%20mysterious%20background%20with%20amber%20highlights%2C%20sophisticated%20artistic%20composition%2C%20editorial%20quality%20with%20soft%20grain%20texture%2C%20bold%20and%20intriguing%20media%20thumbnail%20visual&width=800&height=500&seq=media-4-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            视频精选
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            暴走黑料与黑料社精选视频内容，视觉化吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/80 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-50/80 text-xs text-foreground-700 backdrop-blur-sm">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-background-50/80 text-primary-500 backdrop-blur-sm whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}